import {
  CSProductResourcePage_Sections_Section_Items_Link,
  CSProductResourcePage_Sections_Section_Items_Subsection,
} from '@websrc/Typings/ContentStack'

import type {
  mapResourcePageSection,
  mapSectionLink,
  mapSubSection,
} from '../mapResourcePageSection'

export type Section =
  | CSProductResourcePage_Sections_Section_Items_Link
  | CSProductResourcePage_Sections_Section_Items_Subsection

export type MappedSection = ReturnType<typeof mapResourcePageSection>

export function isLink(
  section: Section
): section is CSProductResourcePage_Sections_Section_Items_Link {
  return (section as CSProductResourcePage_Sections_Section_Items_Link).link !== undefined
}

export function isSubsection(
  section: Section
): section is CSProductResourcePage_Sections_Section_Items_Subsection {
  return (
    (section as CSProductResourcePage_Sections_Section_Items_Subsection).subsection !== undefined
  )
}

export function isMappedSectionLink(
  section: MappedSection
): section is ReturnType<typeof mapSectionLink> {
  return (section as ReturnType<typeof mapSectionLink>).link !== undefined
}

export function isMappedSubsection(
  section: MappedSection
): section is ReturnType<typeof mapSubSection> {
  return (section as ReturnType<typeof mapSubSection>).subsection !== undefined
}
